import moduleInterconsultsWithAppointment from "./moduleInterconsultsWithAppointment";
import moduleInterconsultsWithoutAppointment from "./moduleInterconsultsWithoutAppointment";
import moduleTableInterconsultAdmission from "@/store/interconsults/moduleTableInterconsultAdmission";
import moduleInterconsultsManagement from "@/store/interconsults/moduleInterconsultsManagement";
const exportModulesInterconsults = {
    namespaced: true,
    modules: {
        interconsultsWithoutAppointment: moduleInterconsultsWithoutAppointment,
        interconsultsWithAppointment: moduleInterconsultsWithAppointment,
        interconsultTableAdmission: moduleTableInterconsultAdmission,
        interconsultsManagement: moduleInterconsultsManagement,
    },
};
export default exportModulesInterconsults;
